import accountModule from '../../../app.js';
import emailPhoneTemplate from './email-phone.html';
import {strings} from '@nuskin/ns-common-account';

accountModule.service('strings', function() {
    return strings;
});

var EmailPhone = function() {
    return {
        scope: {
            credentials: '=',
            title: '@',
            isEmailOrPhone: '<',
            isEmail: '<',
            isPhone: '<',
            isRequired: '=',
            isSubmitted: '<',
            isEmailDuplicate: '=',
            isFromPersonal: '<',
            isCheckWithoutFocus: '<',
            profileEmail: '=',
            isSkipBlurValidation: '<'
        },
        controller: EmailPhoneController,
        controllerAs: 'ctrl',
        bindToController: true,
        template: emailPhoneTemplate
    };
};

var EmailPhoneController = function($timeout, $scope, strings) {
    var vmp = this;
    this.emailDuplicatedError = strings.get('tdc_duplicateEmailErrorText');
    this.credentials = this.credentials || {};
    this.isRequired = this.isRequired || false;
    this.isSubmitted = this.isSubmitted || false;
    this.credentials.userDetailsField = this.credentials.userDetailsField || '';
    this.credentials.userEmailField = this.credentials.userEmailField || '';
    this.credentials.userPhoneField = this.credentials.userPhoneField || '';
    this.credentials.emptyEmailError = this.credentials.emptyEmailError || true;
    this.isSkipBlurValidation = this.isSkipBlurValidation || false;
    this.displayFieldSpinner = false;
    this.result = {};
    this.name = 'email.phone';
    this.maskFormat = '';
    this.maskOptions = {
        allowInvalidValue: true,
        clearOnBlur: false
    };

    this.patterns = {
        // eslint-disable-next-line max-len
        email: /^(([^<>()[\]\\.,;:\s@\"]+(\.[^<>()[\]\\.,;:\s@\"]+)*)|(\".+\"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/,
        phone: /^[1-9]{1}[0-9]{9}$/
    };
    this.emailPhoneRequired = strings.get('emailPhoneRequired');
    this.emailPhoneInvalid = strings.get('emailPhoneInvalid');
    this.emailRequired = strings.get('emailRequired');
    this.emailInvalid = strings.get('emailInvalid');
    this.phoneRequired = strings.get('phoneRequired');
    this.phoneInvalid = strings.get('phoneInvalid');

    this.onChange = function(form, flag) {
        if (this.isSkipBlurValidation) {
            this.isRequired = false;
            return;
        }
        var formField;
        if ( this.isPhone ) {
            this.maskFormat = '(999) 999-9999';
            formField = form.userPhoneField;
        } else {
            if (this.isEmail) {
                formField = form.userEmailField;
            } else {
                formField = form.userDetailField;
            }
            var modelValue = formField.$modelValue;
            if (!modelValue) {
                this.maskFormat = '';
            }

            if ( modelValue && modelValue.length == 1 ) {
                if (!isNaN(modelValue)) {
                    this.maskFormat = '(999) 999-9999';
                }
            }
        }

        this.credentials.emptyEmailError = false;

        var isPhone;
        var value;
        if (this.isPhone) {
            value = this.credentials.userPhoneField;
        } else if (this.isEmail) {
            value = this.credentials.userEmailField;
        } else {
            value = this.credentials.userDetailsField;
        }
        if (!value) {
            this.credentials.emptyEmailError = this.isRequired ? true : false;
            return;
        }

        value = value.replace(/[\-()]/g, '');
        var isPhoneNumber = this.patterns.phone.test(value);
        if (isPhoneNumber && value.length == 10) {
            return false;
        }

        if (!this.isEmail) {
            if (value.length > 3 && !isNaN(value)) {
                isPhone = true;
            }
        }


        if (isPhone) {
            var telephoneValue = value.replace(/[^0-9]/g, '').slice(0, 10);
            var city;
            var remainingNumber;

            switch (telephoneValue.length) {
            case 1:
            case 2:
            case 3:
                city = telephoneValue;


            default:
                city = '(' + telephoneValue.slice(0, 3) + ')';
                remainingNumber = telephoneValue.slice(3);
            }

            if (remainingNumber) {
                if (remainingNumber.length < 7) {
                }
                if (remainingNumber.length>3) {
                    remainingNumber = remainingNumber.slice(0, 3) + '-' + remainingNumber.slice(3, 7);
                } else {
                    remainingNumber = remainingNumber;
                }

                value = ( city + remainingNumber).trim();
            } else {
                return '(' + city;
            }
            this.credentials.isPhoneNumber = true;
        } else {
            if (this.isPhone) {
                this.credentials.isPhoneNumber = true;
            } else {
                this.credentials.isPhoneNumber = false;
                if (flag) {
                    // var isEmailValid = this.patterns.email.test(value);
                }
            }
        }
    };

    this.checkUserName = function(form) {
        if (form.userEmailField.$valid) {
            if (vmp.isFromPersonal && this.profileEmail != this.credentials.userEmailField) {
                vmp.displayFieldSpinner = true;
                gigya.accounts.isAvailableLoginID({
                    loginID: this.credentials.userEmailField,
                    callback: function(response) {
                        $timeout(function() {
                            $scope.$apply(function() {
                                vmp.displayFieldSpinner = false;
                            // if(!response.isAvailable) {
                                // vmp.isEmailDuplicate = true;
                            // }
                            });
                        }, 0);
                    }
                });
            }
        }
    };
};

EmailPhoneController.$inject = ['$timeout', '$scope', 'strings'];

accountModule.directive('nsAccountEmailPhone', EmailPhone);



//////////////////
// WEBPACK FOOTER
// ./angular/directives/email-phone/email-phone.js
// module id = 365
// module chunks = 0